import { Component, HostListener, Input, PLATFORM_ID, ViewChild, inject, input } from '@angular/core';
import { ImageModel } from '../../../model/image.model';
import { CarouselComponent, CarouselModule, OwlOptions } from 'ngx-owl-carousel-o';


@Component({
    selector: 'app-image-slider',
    imports: [CarouselModule],
    templateUrl: './image-slider.component.html',
    styleUrl: './image-slider.component.scss'
})
export class ImageSliderComponent {
  @Input() images: ImageModel[] = [];
  @ViewChild('owlCarousel') carousel!: CarouselComponent;

  platformID = inject(PLATFORM_ID);

  customOptions: OwlOptions = {
    mouseDrag: true,
    touchDrag: false,
    pullDrag: true,
    dots: false,
    margin: 32,
    navSpeed: 700,
    navText: ['', ''],
    items: 1,
    loop:false,
    nav: false,
    autoWidth: false,
    responsive: {
      940: {
        autoWidth: true
      }
    }
  }

  customOptions2: OwlOptions = {
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    margin: 32,
    navSpeed: 700,
    navText: ['', ''],
    items: 4,
    nav: true,
    loop:false,
    responsive: {
      0: {
        items: 1
      },
      700: {
        items: 3
      },
      940: {
        items: 4
      }
    },
  }

  goToSlide(index: number) {
    if(this.carousel) {
      this.carousel.to(`${index}`)
    }
  }


}
